import script from "./PromotionInquiry.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromotionInquiry.vue?vue&type=script&setup=true&lang=ts"

import "./PromotionInquiry.vue?vue&type=style&index=0&id=33a4d21d&lang=css"

const __exports__ = script;

export default __exports__